import {
  PROCESS_LINEAGE_REQ,
  PROCESS_LINEAGE_SUCCESS,
  PROCESS_LINEAGE_ERROR
} from './process-lineage.type'

import ApiRest from '@/api/api-rest'

import ProcessLineage from '@/resources/models/ProcessLineage'

const state = {
  processLineageReqStatus: ''
}

const getters = {
  processLineageReqStatus: state => state.processLineageReqStatus
}

// Best Practice - updates state
const mutations = {
  [PROCESS_LINEAGE_REQ]: state => {
    state.processLineageReqStatus = 'loading'
  },
  [PROCESS_LINEAGE_SUCCESS]: (state, data) => {
    state.processLineageReqStatus = 'saved'
  },
  [PROCESS_LINEAGE_ERROR]: (state, errMsg) => {
    state.processLineageReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [PROCESS_LINEAGE_REQ] (context, { agentId, trailId, iocHash }) {
    return new Promise((resolve, reject) => {
      context.commit(PROCESS_LINEAGE_REQ)
      let lineageHashId = encodeURIComponent(`${agentId}:${trailId}:${iocHash}`)
      ApiRest()
        .get(`/trails/trailioclineage/${lineageHashId}`)
        // .get('/static/json/process-lineage.json')
        .then(({ data }) => {
          context.commit(PROCESS_LINEAGE_SUCCESS)
          let processLineage = new ProcessLineage(undefined, {
            processLineageEvents: data
          })
          resolve(processLineage)
        })
        .catch(errMsg => {
          context.commit(PROCESS_LINEAGE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/process_lineage/process-lineage.module.js